module.exports = __webpack_public_path__ + "img/alma.28573ac6.svg";